import script from "./successfulCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./successfulCustomer.vue?vue&type=script&setup=true&lang=js"

import "./successfulCustomer.vue?vue&type=style&index=0&id=d3109508&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3109508"]])

export default __exports__